import React, { createContext, useState } from "react"

export const LayoutContext = createContext()

export const LayoutContextProvider = ({ children }) => {
  const [showUser, setShowUser] = useState(false)
  const [showSideNav, setShowSideNav] = useState(false)
  return (
    <LayoutContext.Provider
      value={{ showUser, setShowUser, showSideNav, setShowSideNav }}
    >
      {children}
    </LayoutContext.Provider>
  )
}
